import axios from 'axios';
import React from 'react';
import StarsIcon from '../../assets/img/rating_stars.png';
import StarsIconDisabled from '../../assets/img/rating_stars_grey.png';
import config from '../../configuration';
import LoadingSkeleton from '../misc/LoadingSkeleton';

const ClinicDepartmentsListItem = ({ id, name, gotoDepartment, rating_count: ratingCount }) => {
  return (
    <div className='clinic-department-list-item' onClick={gotoDepartment} style={{ display: !id ? 'none' : null }}>
      <h2>{name}</h2>
      {/* {
            departmentData.employees?.doctors?.fte && (
              <table style={{ width: '100%' }}>
                <tbody>
                  {/* <tr>
                    <td>
                      <i className='fa fa-user' />
                    </td>
                    <td>
                      {
                    loading
                      ? (
                        <LoadingSkeleton />
                        )
                      : (
                        <>&nbsp;{departmentData.employees.doctors.fte} Vollzeit Ärzt:innen</>
                        )
                  }
                    </td>
                  </tr>  {
                      !loading
                        ? ratingCount && (
                          <tr>
                            <td><i className='fa fa-star' /></td>
                            <td>&nbsp;Bewertung vorhanden</td>
                          </tr>
                          )
                        : (
                          <LoadingSkeleton />
                          )
                    }  <td style={{
                      width: '1%',
                      whiteSpace: 'nowrap'
                    }}
                    >
                    </td>
                </tbody>
              </table>
            )
          } */}

      <i className='fa fa-chevron-right click-icon' />
      <div className={ratingCount ? 'rating-indicator active' : 'rating-indicator'}><img src={ratingCount ? StarsIcon : StarsIconDisabled} style={{ maxHeight: 15, marginBottom: 3, opacity: ratingCount ? 1 : 0.5 }} />&nbsp;&nbsp;{ratingCount ? 'Bewertungen vorhanden' /* ratingCount + (ratingCount > 0 ? ' Bewertungen' : 'Bewertung') */ : 'keine Bewertungen'}</div>
    </div>
  );
};

export default ClinicDepartmentsListItem;
